import { Button, Heading, PageHeader, PageWrapper, Typo } from "#/atoms";
import { FC, memo, } from "react";
import { FONT_SIZE, NATURAL } from "@/theme";
import { OrderFailureProps } from "./OrderFailure.interface";

const OrderFailure: FC<OrderFailureProps> = ({onReturnToOrder }) => {

  return (
    <PageWrapper maxWidth="1024px" margin="auto">
      <PageHeader>
        <Heading scale="h1" fontColor={NATURAL.K} padding="10px">Failure processing payment</Heading>
      </PageHeader>
      <Typo fontColor={NATURAL.G} fontSize={FONT_SIZE.MD} margin="10px 0px 20px" padding="10px" display="inline-block">
      Your payment failed to process, please retry.
      </Typo>
      <br />
      <Button onClick={onReturnToOrder}>Return to your order</Button>
    </PageWrapper>
  );
};

export default memo(OrderFailure);